module.exports = __webpack_public_path__ + "img/list_Story_18.1a3cf461.jpeg";